import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-bootstrap';

import { fetchAuthMe } from '../../shared/session';
import { Auth, Http, Event } from '../../support';

class StartHere extends Component {
  state = {
    data: {},
  };

  constructor(props) {
    super(props);

    const { cliente, empresa, user } = Auth.getData();

    this.state = {
      activation: cliente.config?.activation || {},
      live: window.flowIsLive && empresa.live,
      nombre: user.nombre.split(' ').shift(),
    };
  }

  async componentDidMount() {
    this.setState({
      busy: true,
    });

    try {
      const original = Auth.getData();

      const response = await fetchAuthMe();

      const user = {
        ...response.data,
        empresa: undefined,
        cliente: undefined,
        emisor: undefined,
      };

      const { empresa, emisor, cliente } = response.data;

      const data = {
        ...original,
        user,
        empresa: {
          ...empresa,
          live: window.flowIsLive && empresa.live,
        },
        emisor: emisor || {},
        cliente: cliente || {},
      };

      await Auth.setData(data);

      this.setState({
        busy: false,
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: error.message || 'Error al sincronizar tu sesión',
      });
    }
  }

  componentDidUpdate() {
    const { empresa } = Auth.getData();

    if (empresa.live !== this.state.live) {
      this.setState({
        live: empresa.live,
      });
    }
  }

  getLinkAsForStep(step) {
    const { activation } = this.state;

    let type = activation[step] === true ? 'div' : Link;

    return type;
  }

  getClassNamesForStep(step) {
    const { cliente, empresa } = Auth.getData();
    const { activation: _activation = {} } = cliente.config || {};

    const activation = {
      ..._activation,
    };

    if (step === 'live') {
      activation.live = window.flowIsLive && empresa.live;
    }

    let className = activation[step] === true ? 'step complete' : 'step';

    return className;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  goLive = async () => {
    if (this.state.busy) {
      return;
    }

    this.setState({
      error: undefined,
      activating: true,
    });

    try {
      const body = {
        live: true,
      };

      const response = await Http.patch(`auth/me/live`, body);

      this.setState({
        activating: false,
        live: response.data.live,
      });

      Event.dispatch('go.live');
    } catch (error) {
      this.setState({
        activating: false,
      });

      const _error = error.data || error;

      window.ToastManager.show({
        variant: 'error',
        title: 'Error',
        message: _error.message || 'Error al pasar a modo live',
      });
    }
  };

  render() {
    const { activating, live, nombre } = this.state;
    const { showTest = true } = this.props;

    return (
      <>
        <div className="row my-3 bg-light-gray">
          <div className="col">
            <h4>Hola {nombre}!</h4>

            <p>Estas son las primeras acciones que puedes tomar para para comenzar a usar nuestra plataforma.</p>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12 col-md-10 col-lg-8">
            {showTest && !live && (
              <div className="media pb-5">
                <div
                  className="thumbnail pull-left text-center mt-1"
                  style={{ width: '100px' }}
                >
                  <img
                    className="media-object"
                    src="https://cdn-icons-png.flaticon.com/512/5513/5513017.png"
                    alt="Ambiente de pruebas"
                    style={{ width: '50px' }}
                  />
                </div>
                <div className="media-body">
                  <h6 className="media-heading">Tu ambiente de pruebas</h6>
                  <p>Es muy fácil comenzar a probar nuestra plataforma creando facturas de prueba.</p>

                  <p>
                    Las facturas de prueba no son enviadas al SAT, por lo tanto no tienen validez fiscal y no consumen
                    tus hits.
                    <br />
                    <br />
                    Listo?
                  </p>

                  <div className="activation">
                    <div className={this.getClassNamesForStep('registro_emisor_test')}>
                      <NavLink
                        as={this.getLinkAsForStep('registro_emisor_test')}
                        onClick={this.scrollToTop}
                        to="/app/emisores/registrar?intro=1"
                      >
                        <span className="indicator">1</span>
                        <span className="title">Sube un Certificado de Sello Digital de prueba</span>
                      </NavLink>
                    </div>

                    <div className="step complete">
                      <NavLink
                        as={this.getLinkAsForStep('registro_receptor_test')}
                        onClick={this.scrollToTop}
                        to="/app/receptores/registrar?intro=1"
                      >
                        <span className="indicator">2</span>
                        <span className="title">Registra un receptor (Opcional)</span>
                      </NavLink>
                    </div>

                    <div className={this.getClassNamesForStep('factura_test')}>
                      <NavLink
                        as={this.getLinkAsForStep('factura_test')}
                        onClick={this.scrollToTop}
                        to="/app/comprobantes/timbrado?intro=1"
                      >
                        <span className="indicator">2</span>
                        <span className="title">Crea tu primer factura de prueba</span>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="media pb-5">
              <div
                className="thumbnail pull-left text-center mt-1"
                style={{ width: '100px' }}
              >
                <img
                  className="media-object"
                  src="https://cdn-icons-png.flaticon.com/512/2098/2098316.png"
                  alt="Configura tu cuenta"
                  style={{ width: '50px' }}
                />
              </div>
              <div className="media-body">
                <h6 className="media-heading">Configura tu cuenta</h6>
                <p>
                  Agrega la siguiente información para obtener acceso al ambiente Live y emitir facturas con validez
                  fiscal.
                </p>

                <div className="activation">
                  <div className={this.getClassNamesForStep('email_confirm')}>
                    <NavLink
                      as={this.getLinkAsForStep('email_confirm')}
                      onClick={this.scrollToTop}
                      to="/cuenta/config/confirmacion?intro=1"
                    >
                      <span className="indicator">1</span>
                      <span className="title">Confirma tu correo electrónico</span>
                    </NavLink>
                  </div>

                  <div className={this.getClassNamesForStep('billing_info')}>
                    <NavLink
                      as={this.getLinkAsForStep('billing_info')}
                      onClick={this.scrollToTop}
                      to="/cuenta/config/informacion-de-facturacion?intro=1"
                    >
                      <span className="indicator">2</span>
                      <span className="title">Completa tu información de facturación</span>
                    </NavLink>
                  </div>

                  <div className={this.getClassNamesForStep('registro_emisor')}>
                    <NavLink
                      as={this.getLinkAsForStep('registro_emisor')}
                      onClick={this.scrollToTop}
                      to="/app/emisores/registrar?intro=1&t=l"
                    >
                      <span className="indicator">3</span>
                      <span className="title">Sube tu Certificado de Sello Digital</span>
                    </NavLink>
                  </div>

                  <div className="step complete">
                    <NavLink
                      as={this.getLinkAsForStep('registro_receptor')}
                      onClick={this.scrollToTop}
                      to="/app/receptores/registrar?intro=1"
                    >
                      <span className="indicator">4</span>
                      <span className="title">Registra un receptor (Opcional)</span>
                    </NavLink>
                  </div>

                  <div className={this.getClassNamesForStep('hits')}>
                    <NavLink
                      as={this.getLinkAsForStep('hits')}
                      onClick={this.scrollToTop}
                      to="/cuenta/paquetes?intro=1"
                    >
                      <span className="indicator">5</span>
                      <span className="title">Adquiere un paquete de hits</span>
                    </NavLink>
                  </div>
                </div>
              </div>
            </div>

            <div className="media pb-5">
              <div
                className="thumbnail pull-left text-center mt-1"
                style={{ width: '100px' }}
              >
                <img
                  className="media-object"
                  src="https://cdn-icons-png.flaticon.com/512/5513/5513656.png"
                  alt="Crea facturas con validéz fiscal"
                  style={{ width: '50px' }}
                />
              </div>
              <div className="media-body">
                <h6 className="media-heading">Crea tus facturas con validéz fiscal</h6>
                <p>Estás a nada de poder emitir facturas con validez fiscal, solo completa los siguientes pasos.</p>
                <div className="activation">
                  <div className={this.getClassNamesForStep('live')}>
                    <NavLink
                      as={'div'}
                      className="cursor-pointer"
                      style={{ color: '#007bff' }}
                      onClick={this.goLive}
                      to="/app/live?intro=1"
                    >
                      <span className="indicator">1</span>
                      <span className="title">{activating ? 'Activando' : 'Activa tu ambiente Live'}</span>
                    </NavLink>
                  </div>

                  {live && window.flowIsLive && (
                    <div className={this.getClassNamesForStep('factura')}>
                      <NavLink
                        as={this.getLinkAsForStep('factura')}
                        onClick={this.scrollToTop}
                        to="/app/comprobantes/timbrado?intro=1"
                      >
                        <span className="indicator">2</span>
                        <span className="title">Crea tu primer factura</span>
                      </NavLink>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default StartHere;
